import { PlanModel } from './plan-model';

export class StakingSettingsModel {
  normalRewardEndTime: number;
  startStaking: number;
  doubleRewardEndTime: number;
  plans: PlanModel[];

  constructor(normalRewardEndTime: number, startStaking: number, doubleRewardEndTime: number, plans: PlanModel[]) {
    this.normalRewardEndTime = normalRewardEndTime;
    this.startStaking = startStaking;
    this.doubleRewardEndTime = doubleRewardEndTime;
    this.plans = plans;
  }
}
